import {
  ChipField,
  Datagrid,
  FunctionField,
  List,
  NumberField,
  TextField,
} from 'react-admin';
import { FrameworksCommandPanel } from './FrameworksCommandPanel';
import { Chip } from '@mui/material';

const entityTypes = {
  journalEntries: 'Patient - Journal Entries',
  therapistSessionNotes: 'Therapist - Session Notes',
  therapistHomework: 'Therapist - Homework',
};

const choices = Object.entries(entityTypes).map(([id, name]) => ({
  id,
  name,
}));

export const FrameworksList = () => (
  <List
    resource="therapistSessionNotesFrameworks"
    queryOptions={{ meta: { raw: true } }}
    sort={{ field: 'sortOrder', order: 'ASC' }}
  >
    <Datagrid
      bulkActionButtons={false}
      expand={FrameworksCommandPanel}
    >
      <TextField source="id" />
      <NumberField label="Sort Order" source="sortOrder" />
      <ChipField source="name" />
      <FunctionField
        source="deletedAt"
        label="Available?"
        render={(record: any) => (
          <Chip label={!!record.deletedAt ? '🔴' : '🟢'} />
        )}
      />
    </Datagrid>
  </List>
);
